export default "__VITE_ASSET__BAHOmqUo__"